<tool-drawer-container [shouldShowToggleBtn]="false">
  <tool-header
    class="tool-header"
    headerTitle="Transfer Enrollment and Trends"
    [pathBreadcrumbs]="
      toolListService.getHelpPagePathBreadcrumbs('transfer_students_trends')
    "
  ></tool-header>

  <div class="tool-content-container main-content">
    <div class="tool-description">
      Below are the step by step instructions on how to use Transfer Enrollment
      and Trends Tool. The Transfer Enrollment and Trends Tool lets you view
      enrollment trend, student data, and retention/graduation rates for
      transfer students.
    </div>

    <div class="tool-div">
      <div class="left-align-div">
        <h1 class="h1-header">
          Admin Support Section
          <i class="fa-solid fa-arrow-right"></i> Transfer Enrollment and Trends
        </h1>

        <div class="buttons-nav">
          <div class="example-button-row">
            <a
              (click)="scroll(formguide)"
              [ngStyle]="{
                color: isHovered[0]
                  ? env['colors']['tool_btn_active']
                  : 'black',
              }"
              (mouseover)="setHover(0, true)"
              (mouseout)="setHover(0, false)"
            >
              Enrollment and Trends Filter Guide
            </a>
            <span> &nbsp; | &nbsp; </span>
            <a
              (click)="scroll(results)"
              [ngStyle]="{
                color: isHovered[1]
                  ? env['colors']['tool_btn_active']
                  : 'black',
              }"
              (mouseover)="setHover(1, true)"
              (mouseout)="setHover(1, false)"
            >
              Transfer Enrollment and Trends Graphs Result
            </a>
          </div>
        </div>

        <!---------- Transfer Enrollment and Trends Tool At First Glance ---------->
        <h3 class="h3-second-header">
          Transfer Enrollment and Trends Tool At First Glance
        </h3>

        <ol class="ordered-list">
          <li>
            Once you get to the page, you will be able to see something like the
            image below in Figure 63.
          </li>
        </ol>

        <div>
          <br />
          <img
            class="small-pics"
            [(src)]="env['logo_paths']['helpPageTransferEnrollmentTrends63']"
            alt=""
          />
          <p class="picture-caption">
            Figure 63: Transfer Enrollment and Trends Tool Page
          </p>
        </div>

        <div #formguide></div>
        <br />
        <mat-divider></mat-divider>
        <br />
      </div>

      <!---------- Transfer Enrollment and Trends Form Guide ---------->
      <div class="left-align-div">
        <h3 class="h3-second-header">
          Transfer Enrollment and Trends Form Submission
        </h3>

        <ol class="unordered-list">
          <li>
            Select Admit Type (All, Other Undergraduate Transfer, Transfer From
            Florida College System)
          </li>
          <li>
            Select Associate Degree (All, Associate in Arts (AA), Associate in
            Science (AS))
          </li>
          <li>Select Full/Part-Time Indicator (All, Full-Time, Part-Time)</li>
          <li>Select Graduation Time (Two-Year, Three-Year)</li>
          <li>
            Select a College (All; Lewis Bear Jr College of Business; College of
            Arts, Social Sciences and Humanities; Usha Kundu, MD College of
            Health; Hal Marcus of College of Science and Engineering; School of
            Education; No College Designated)
          </li>
          <li>Select a Department</li>
          <li>Select a Program</li>
          <li>Select a Transfer College Name</li>
          <li>Click the submit button</li>
        </ol>
        <div>
          <p></p>
          <img
            class="set-img-width-sm"
            [(src)]="env['logo_paths']['helpPageTransferEnrollmentTrends64']"
            alt=""
          />
          <p class="picture-caption">
            Figure 64: Default inputs for Transfer Enrollment and Trends input
            fields
          </p>
        </div>
      </div>

      <!--------------- Results After Form Submission Explanation --------------->
      <div class="left-align-div" #results>
        <br />
        <mat-divider></mat-divider>
        <br />

        <h3 class="h3-second-header">Results after Form Submission</h3>

        <ul class="unordered-list">
          <li>
            After you change the form fields’ values to your desired values, the
            form will automatically submit itself.
          </li>
          <li>
            The results will be regenerated based on the new input values.
          </li>
          <li>
            You can also click on the colored boxes that’s below the graphs to
            remove any line/bar on the graphs based on the color.
          </li>
          <div>
            <p></p>
            <img
              class="set-img-width-med"
              [(src)]="env['logo_paths']['helpPageTransferEnrollmentTrends65']"
              alt=""
            />
            <p class="picture-caption">
              Figure 65: Transfer Enrollment and Trends graph (1)
            </p>
          </div>
          <div>
            <p></p>
            <img
              class="set-img-width-med"
              [(src)]="env['logo_paths']['helpPageTransferEnrollmentTrends65a']"
              alt=""
            />
            <p class="picture-caption">
              Figure 65a: Transfer Enrollment and Trends graph (2)
            </p>
          </div>
          <div>
            <p></p>
            <img
              class="set-img-width-med"
              [(src)]="env['logo_paths']['helpPageTransferEnrollmentTrends65b']"
              alt=""
            />
            <p class="picture-caption">
              Figure 65b: Transfer Enrollment and Trends graph (3)
            </p>
          </div>
        </ul>
      </div>
    </div>
  </div>

  <related-links
    class="right-sidenav"
    [links]="
      toolListService.getAdminSupportRelatedLinkBasedOnTool(
        'Transfer Enrollment and Trends',
        true
      )
    "
  ></related-links>
</tool-drawer-container>
